import React from 'react'

import Modal from '../../../../../../components/structure/Modal'
import ModalHeader from './sections/ModalHeader'
import TriggersTable from './table/TriggersTable'
import ModalFooter from './sections/ModalFooter'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import { useChecklistForm } from '../../../_form/ChecklistFormHandler'
import { useChecklistFormActions } from '../../../_form/ChecklistFormHandler'
import TriggersLoader, { useTriggers } from './_load/TriggersLoader'

const RemoveModal = ({ isCategory, index }) => {
  const { triggersCategoryCheckModalOpen, triggersQuestionCheckModalOpen } = useChecklistForm()
  const { closeTriggersCategoryCheckModal, closeTriggersQuestionCheckModal } = useChecklistFormActions()
  const triggers = useTriggers()

  const open = isCategory ? triggersCategoryCheckModalOpen : triggersQuestionCheckModalOpen
  const onClose = isCategory ? closeTriggersCategoryCheckModal : closeTriggersQuestionCheckModal
  const hasMoreThanOneTrigger = triggers.length > 1

  return (
    <Modal open={open} onClose={onClose} width="72rem">
      <ModalHeader hasMoreThanOneTrigger={hasMoreThanOneTrigger} isCategory={isCategory} />
      <Separator weight={4} />
      <TriggersTable data={triggers} />
      <Separator weight={6} />
      <ModalFooter isCategory={isCategory} index={index} />
    </Modal>
  )
}

const ModalWrapper = ({ questionIds, isCategory, index }) => {
  return (
    <TriggersLoader isCategory={isCategory} filter={{ questionIds }}>
      <RemoveModal isCategory={isCategory} index={index} />
    </TriggersLoader>
  )
}

export default ModalWrapper
